import { render } from "./TeamList.vue?vue&type=template&id=1e03ccb8&ts=true"
import script from "./TeamList.vue?vue&type=script&lang=ts"
export * from "./TeamList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__